import { Alert } from "antd";

const AuthAlert = ({ msg, type = "error" }) => {
  return (
    <div className="my-2.5">
      {msg && (
        <Alert message={msg} type={type} showIcon className="px-2.5 py-1 rounded-md text-sm" />
      )}
    </div>
  );
};

export default AuthAlert;
